import locale_en from './en-CA.json';
import routes_en from './en-routes.json';
import locale_fr from './fr-CA.json';
import routes_fr from './fr-routes.json';
import transactions from './transactions.json';

export const appLocales = {
    en: 'en',
    fr: 'fr',
};

const { en, fr } = appLocales;

export const appRoutesByLocal = {
    [en]: routes_en,
    [fr]: routes_fr,
};

export const appStrings = {
    [en]: { ...locale_en, ...routes_en },
    [fr]: { ...locale_fr, ...routes_fr },
};

export const formats = {
    number: {
        CAD: {
            currency: 'CAD',
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
            style: 'currency',
        },
        percentage: {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
            style: 'percent',
        },
    },
};

export { transactions as TRANSACTION_DESCRIPTIONS };
